var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-message-form-presenter"},[_c('b-alert',{class:{ 'move-alert-up': _vm.moveUp },attrs:{"show":"","fade":"","variant":_vm.variant}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }